import React from 'react';

const ScheduleIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_6067_10091"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.67 13.13C18.04 14.06 19 15.32 19 17V20H23V17C23 14.82 19.43 13.53 16.67 13.13Z"
          fill="#A9A5B6"
        />
        <path
          d="M9 12C11.2091 12 13 10.2091 13 8C13 5.79086 11.2091 4 9 4C6.79086 4 5 5.79086 5 8C5 10.2091 6.79086 12 9 12Z"
          fill="#A9A5B6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C14.53 4 14.09 4.1 13.67 4.24C14.5 5.27 15 6.58 15 8C15 9.42 14.5 10.73 13.67 11.76C14.09 11.9 14.53 12 15 12Z"
          fill="#A9A5B6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 13C6.33 13 1 14.34 1 17V20H17V17C17 14.34 11.67 13 9 13Z"
          fill="#A9A5B6"
        />
      </mask>
      <g mask="url(#mask0_6067_10091)">
        <rect width="24" height="24" fill="#8E899F" />
      </g>
    </svg>
  );
};

export default ScheduleIcon;
